import { render, staticRenderFns } from "./ValidationPage.vue?vue&type=template&id=148e085c&scoped=true&"
import script from "./ValidationPage.vue?vue&type=script&lang=js&"
export * from "./ValidationPage.vue?vue&type=script&lang=js&"
import style0 from "./ValidationPage.vue?vue&type=style&index=0&id=148e085c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e085c",
  null
  
)

export default component.exports